<template>
    <div class="profile">
        <div class="mobile-text">
            <div class="profile-title">Teach:able</div>
            <div class="profile-part">
                <p>
                    <img src="../assets/img/mobile/user-icon.png">
                    My Profile
                </p>
            </div>
        </div>
        <div class="profile-box">
            <div class="image">
                <img src="../assets/img/student-profile-image.png" v-if="imgData == '' ">
                <img :src="imgData" v-else style="box-shadow: 0px 5px 15px #00000029;">
                <p @click="showUploadImg">Upload your photo</p>
            </div>
            <div class="form">
                <div class="form-item">
                    <div class="title">Full Name</div>
                    <div class="input"><el-input v-model="form.name" /></div>
                </div>
                <div class="form-item">
                    <div class="title">Email Address</div>
                    <div class="input"><el-input v-model="form.email" /></div>
                </div>
                <div class="form-item medium left">
                    <div class="title">Password</div>
                    <div class="input"><el-input type="password" v-model="form.password" /></div>
                </div>
                <div class="form-item medium">
                    <div class="title">Confirm Password</div>
                    <div class="input"><el-input type="password" v-model="form.password2" /></div>
                </div>
                <div class="button medium">
                    <el-button v-loading="isButtonLoading" @click="submitUpdate()">Save Changes</el-button>
                </div>
            </div>
        </div>
        <div class="upload-image">
            <my-upload
                field="img"
                @crop-success="cropImgSuccess"
                @crop-upload-success="cropUploadSuccess"
                @crop-upload-fail="cropUploadFail"
                v-model="isImgUploadShow"
                :langExt="uploadImageHints"
                :width="300"
                :height="300"
                img-format="png">
            </my-upload>
        </div>
    </div>
</template>

<script>
    /* upload image */
    import myUpload from 'vue-image-crop-upload';

    export default {
        name: "Profile",
        components: {
			'my-upload': myUpload
		},
        data() {
            return {
                form:{
                    img: '',
                    name:'',
                    email:'',
                    password:'',
                    password2:''
                },

                /* upload image */
                uploadImageHints: {
                    hint: 'Click or drag the image here to upload',
                    loading: 'Uploading…',
                    noSupported: 'Browser is not supported, please use IE10+ or other browsers',
                    success: 'Upload success',
                    fail: 'Upload failed',
                    preview: 'Preview',
                    btn: {
                        off: 'Cancel',
                        close: 'Close',
                        back: 'Back',
                        save: 'Save'
                    },
                    error: {
                        onlyImg: 'Image only',
                        outOfSize: 'Image exceeds size limit: ',
                        lowestPx: 'Image\'s size is too low. Expected at least: '
                    }
                },
                isImgDataShow: false,
                isImgUploadShow: false,
                imgData: '', // the datebase64 url of created image
                /* //upload image */

                isButtonLoading: false,
            }
        },
        mounted () {
            this.init();
        },
        methods: {
            init() {
                this.$api.request('User/info').then((result) => {
                    if (result.status == true) {
                        let results = result.data;
                        this.form = {
                            name: results.name,
                            email: results.email
                        }
                    } else {
                        this.$message.error(result.msg);
                    }
                }).catch(error => {
                    this.$message.error(error.msg);
                });
            },

            /* upload image */
            showUploadImg() {
                this.isImgUploadShow = !this.isImgUploadShow;
                console.log("this.imgData="+ this.imgData);
            },
			cropImgSuccess(imgData){
                this.form.img = imgData;
				this.imgData = imgData;
                this.isImgDataShow = true;
			},
			cropUploadSuccess(){
            },
			cropUploadFail(){
            },

            submitUpdate() {
                console.log(this.form);
            }
        },
    }
</script>

<style lang='scss' type='text/css'>
    @import "../styles/pc/Profile.scss";
    @import "../styles/mobile/Profile.scss";
</style>
